export default "__VITE_ASSET__DxPi$SrT__"